import { LayerProps } from "react-map-gl/maplibre";

import {
	GEOMETRY_TYPE,
	LabelsConfigs,
} from "~map-style-utils/types/__generated/gql/graphql";

export const getLabelsStyle = (
	sourceId: string,
	geometryType: GEOMETRY_TYPE,
	configs: LabelsConfigs,
): LayerProps => {
	switch (geometryType) {
		case GEOMETRY_TYPE.POINT:
			return {
				id: getLabelsLayerId(sourceId),
				type: "symbol",
				source: sourceId,
				layout: {
					"text-field": ["get", configs.attribute ?? ""],
					"text-size": configs.fontSize ?? 12,
					"text-justify": "center",
					"text-anchor": "bottom",
					"text-offset": [0, -0.5],
					"text-allow-overlap": false,
					"text-padding": 10,
					"icon-optional": true,
				},
				paint: {
					"text-color": configs.fontColour ?? "#000000",
					"text-halo-color": configs.haloColour ?? "#ffffff",
					"text-halo-width": configs.haloSize ?? 1,
					"text-opacity": configs.fontOpacity ?? 1,
					"text-halo-blur": configs.haloOpacity ?? 1,
				},
			};
		case GEOMETRY_TYPE.LINE:
			return {
				id: getLabelsLayerId(sourceId),
				type: "symbol",
				source: sourceId,
				layout: {
					"text-field": ["get", configs.attribute ?? ""],
					"text-size": configs.fontSize ?? 12,
					"symbol-placement": "line",
					"symbol-spacing": 400,
					"text-rotation-alignment": "map",
					"text-allow-overlap": false,
				},
				paint: {
					"text-color": configs.fontColour ?? "#000000",
					"text-halo-color": configs.haloColour ?? "#ffffff",
					"text-halo-width": configs.haloSize ?? 1,
				},
			};
		case GEOMETRY_TYPE.POLYGON:
			return {
				id: getLabelsLayerId(sourceId),
				type: "symbol",
				source: sourceId,
				layout: {
					"text-field": ["get", configs.attribute ?? ""],
					"text-size": configs.fontSize ?? 12,
					"text-anchor": "center", // Position the text at the center of the polygon
					"text-allow-overlap": false, // Prevent overlapping labels
					"text-padding": 10,
				},
				paint: {
					"text-color": configs.fontColour ?? "#000000",
					"text-halo-color": configs.haloColour ?? "#ffffff",
					"text-halo-width": configs.haloSize ?? 1,
				},
			};
		default:
			throw new Error("Invalid geometry type");
	}
};

export const getLabelsLayerId = (sourceId: string): string =>
	`${sourceId}-labels`;
